import { default as MuiBreadcrumbs, BreadcrumbsProps } from '@mui/material/Breadcrumbs'
import * as React from 'react'

export const Breadcrumbs: React.FC<React.PropsWithChildren<BreadcrumbsProps>> = (props) => {
  return <MuiBreadcrumbs {...props} />
}

export default Breadcrumbs
